import { createSelector } from 'reselect';
import PredesComplianceMissingRequiredElementsDetailsColumns
  from '../../containers/PredesComplianceMissingRequiredElementsDetailsColumns';
import ReportDefinitions from '../../../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting
    .PREDES_COMPLIANCE_MISSING_REQUIRED_ELEMENTS_DETAILS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting
    .PREDES_COMPLIANCE_MISSING_REQUIRED_ELEMENTS_DETAILS.isLoading;

export const getData =
  ReportDefinitions
    .PREDES_COMPLIANCE_MISSING_REQUIRED_ELEMENTS_DETAILS.getDataFunction();

export const getColumns =
  createSelector(getData, PredesComplianceMissingRequiredElementsDetailsColumns);
